const FULL_WIDTH_PREFERENCE_KEY = 'appFullWidth'

export function readFullWidthPreference() {
  try {
    const raw = sessionStorage.getItem(FULL_WIDTH_PREFERENCE_KEY)
    if (raw === null) return true
    return raw === 'true'
  } catch {
    return true
  }
}

export function writeFullWidthPreference(enabled) {
  try {
    sessionStorage.setItem(FULL_WIDTH_PREFERENCE_KEY, enabled ? 'true' : 'false')
  } catch {}
}
